/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { AbstractControl } from '@angular/forms'
import moment from 'moment/min/moment-with-locales'

export const minDate = (date: string, format: string) => {
  return (control: AbstractControl) => {
    if (!control.value) return null
    const controlDate = moment(control.value, format, true)

    const minDateMoment = moment(date, format, true)
    if (controlDate.isValid() && minDateMoment.isValid()) {
      if (controlDate.isSameOrBefore(minDateMoment)) {
        return { minDate: true }
      }
    }
    return null
  }
}
